<div class="wrapper wrapper-content animated fadeInRight">
  <div class="pos card" id="pos">
    <div class="pos-container card-body">



      <div class="pos-content">

        <div class="nav-wizards-container">
          <nav class="nav nav-wizards-1 mt-3 mb-2">
            <!-- completed -->
            <div class="nav-item col">
              <a class="nav-link" [ngClass]="{'completed':wizardStep>0,'active':wizardStep==0}" (click)="wizardStep = 0">
                <div class="nav-no">1</div>
                <div class="nav-text">Choose License Size</div>
              </a>
            </div>
  
            <!-- active -->
            <div class="nav-item col">
              <a class="nav-link" [ngClass]="{'completed':wizardStep>1,'active':wizardStep==1}" (click)="wizardStep = 1">
                <div class="nav-no">2</div>
                <div class="nav-text">Select Plugins</div>
              </a>
            </div>
  
            <!-- active -->
            <div class="nav-item col">
              <a class="nav-link" [ngClass]="{'completed':wizardStep>2,'active':wizardStep==2}" (click)="wizardStep = 2">
                <div class="nav-no">3</div>
                <div class="nav-text">Confirm Selection</div>
              </a>
            </div>
  
            <!-- disabled -->
            <div class="nav-item col">
              <a class="nav-link disabled" href="#">
                <div class="nav-no">4</div>
                <div class="nav-text">Purchased</div>
              </a>
            </div>
          </nav>
        </div>

        <div class="pos-content-container h-100 p-4 ps ps--active-y" data-scrollbar="true" data-height="100%" style="height: 100%;" data-init="true">
        <div class="row" *ngIf="wizardStep === 0">
          <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-4 col-sm-6 pb-4" *ngFor="let option of options; let i = index;">
            <div class="card mt-3 bg-emphasis bg-opacity-25"
              [ngClass]="{'bg-emphasis':this.formModel.uriOption == option}" (click)="selectPlan(option)">
              <div class="card-body product-box" [ngClass]="this.formModel.uriOption == option ? 'selected' : ''">
                <div class="product-imitation">
                  {{ option.title }} Points
                </div>
                <div class="product-desc">
                  <span class="product-price" *ngIf="option.price == 0">
                    TRIAL
                  </span>
                  <span class="product-price" *ngIf="option.price > 0">
                    AU${{option.price}}
                  </span>
  
                  <div class="small m-t-xs mt-5">
                    <li class="list-group-item">Input Items <strong class="text-info"> {{ option.input_Items}}</strong>
                    </li>
                  </div>
  
                </div>
              </div>
              <div class="card-arrow">
                <div class="card-arrow-top-left"></div>
                <div class="card-arrow-top-right"></div>
                <div class="card-arrow-bottom-left"></div>
                <div class="card-arrow-bottom-right"></div>
              </div>
            </div>
          </div>
        </div>
  
        <div *ngIf="wizardStep === 1">
  
          <tabset type="pills" [vertical]="false">
            <tab *ngFor="let category of categories" [heading]="getName(category)">
              <div class="row tabrow">
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                  *ngFor="let plugin of plugins | findPluginsByCategory : category;let i = index;">
                  <div class="card" class="card mt-3"
                    (click)="selectOptions(plugin)">
                    <div class="card-body product-box bg-opacity-30"
                      [ngClass]="this.formModel.SelectedPlugins.includes(plugin)  ? 'bg-emphasis' : ''">
                      <div class="product-imitation plugin">
                        {{plugin.name}}
                      </div>
                      <div class="product-desc plugin">
                        <span class="product-price" *ngIf="plugin.price <= 0">
                          FREE
                        </span>
                        <span class="product-price" *ngIf="plugin.price > 0">
                          AU${{plugin.price}}
                        </span>
                        <div class="plugin-description small m-t-xs">
                          <li class="list-group-item"><span [title]="plugin.description">{{ plugin.description}}</span>
                          </li>
                          <li class="list-group-item">
                            <span *ngIf="plugin.pluginStatus == 1" class="label label-plain">Pre-release</span>
                            <span *ngIf="plugin.pluginStatus == 2" class="label label-success">In Development</span>
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="card-arrow">
                      <div class="card-arrow-top-left"></div>
                      <div class="card-arrow-top-right"></div>
                      <div class="card-arrow-bottom-left"></div>
                      <div class="card-arrow-bottom-right"></div>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
          </tabset>
  
        </div>
  
        <div class="row" *ngIf="wizardStep === 2">
          <div class="col-md-12">
            <h2>Confirmation</h2>
          </div>
          <div class="col-md-12">
            <div class="ibox">
              <div class="ibox-content">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Option</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>License</td>
                      <td>{{formModel.uriOption.title}}</td>
                      <td>AU${{formModel.uriOption.price}}</td>
                    </tr>
                    <tr *ngFor="let plugin of formModel.SelectedPlugins">
                      <td>Plugin</td>
                      <td>{{plugin.name}}</td>
                      <td>AU${{plugin.price}}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th>Total</th>
                      <th></th>
                      <th>AU${{formModel.Price}}</th>
                    </tr>
                  </tfoot>
                </table>
                <h4>Your Licence</h4>
                <div>Your license will entitle you to download and install the INDICIUM DataBus Edge, and allow you to
                  download upgrades for 12 months from the confirmation of payment. Once your 12 months have expired you
                  will be able to continue using your INDICIUM DataBus, but if you need to upgrade or want to use our
                  suppor services you will need to renew your license for another 12 months.</div>
                <div>You will be able to generate a license file once payment has been received, and you should keep a
                  copy of your license in case you need to install it again.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
        
      </div>


      <div class="pos-sidebar" id="pos-sidebar">
        <div class="h-100 d-flex flex-column p-0">

          <div class="pos-sidebar-header">
            <div class="title">DataBus License Order</div>
          </div>

          <div class="pos-sidebar-header">
           <div class="form-group">
              <label>Give your license a name:</label>
              <input type="text" placeholder="Enter name" class="form-control" name="name" [(ngModel)]="formModel.LicenseName"  [ngClass]="{'is-invalid': formModel.LicenseName == null || formModel.LicenseName == ''}">
            </div>
          </div>


          <div class="pos-sidebar-body tab-content ps" data-scrollbar="true" data-height="100%" style="height: 100%;" data-init="true">

            <div class="tab-pane fade h-100 show active" id="newOrderTab" role="tabpanel">

              <div class="pos-order" *ngIf="formModel.Price != null">
                <div class="pos-order-product">
                  
                  <div class="flex-1" >
                    <div class="h6 mb-1">INDICIUM DataBus License</div>
                    <div class="small">${{formModel.Price}}</div>
                    <div class="small mb-2">{{formModel.uriOption.title}}</div>
                    <!--<div class="d-flex">
                      <a href="#" class="btn btn-outline-theme btn-sm"><i class="fa fa-minus"></i></a>
                      <input type="text"
                        class="form-control w-50px form-control-sm mx-2 bg-white bg-opacity-25 text-center" value="01">
                      <a href="#" class="btn btn-outline-theme btn-sm"><i class="fa fa-plus"></i></a>
                    </div>-->
                  </div>
                </div>
                <div class="pos-order-price">
                  ${{formModel.Price}}
                </div>
              </div>

              <div class="pos-order" *ngIf="formModel.SelectedPlugins == null || formModel.SelectedPlugins.length == 0">
                <div class="pos-order-product">
                  <div class="flex-1">
                    <div class="h6 mb-1">No Plugins Selected</div>
                    <div class="small">$0.00</div>
                  </div>
                </div>
                <div class="pos-order-price">
                  $0.00
                </div>
                <!--<div class="pos-order-confirmation text-center d-flex flex-column justify-content-center">
                  <div class="mb-1">
                    <i class="bi bi-trash fs-36px lh-1"></i>
                  </div>
                  <div class="mb-2">Remove this item?</div>
                  <div>
                    <a href="#" class="btn btn-outline-default btn-sm ms-auto me-2 width-100px">No</a>
                    <a href="#" class="btn btn-outline-theme btn-sm width-100px">Yes</a>
                  </div>
                </div>-->
              </div>

              <!--<div *ngIf="formModel && formModel.SelectedPlugins">
                <div class="summary-item product-box" *ngFor="let plugin of formModel.SelectedPlugins; let i = index;">
                  <a href="#" class="product-name">{{plugin.name}}</a>
                  <div class="small m-t-xs description">
                    {{plugin.description}}
                  </div>
  
                  <div class="row ml-1 m-t ">
                    <div>
                      <button class="btn btn-xs btn-outline btn-danger"
                        (click)="removePlugin(plugin.name)">Remove</button>
                    </div>
                    <div class="ml-auto mr-3">
                      <span class="btn btn-xs btn-outline btn-primary">AU${{plugin.price}}</span>
                    </div>
                  </div>
  
                </div>
              </div>-->

              <div *ngIf="formModel && formModel.SelectedPlugins">
              <div class="pos-order" *ngFor="let plugin of formModel.SelectedPlugins; let i = index;">
                <div class="pos-order-product">
                  <div class="flex-1">
                    <div class="h6 mb-1">{{plugin.name}}</div>
                    <div class="small">${{plugin.price}}</div>
                    <!--<div class="small mb-2">
                      {{plugin.description}}
                    </div>-->
                    <div class="d-flex">
                      <a class="btn btn-outline-theme btn-sm" (click)="removePlugin(plugin)"><i class="fa fa-trash"></i></a>
                    </div>
                  </div>
                </div>
                <div class="pos-order-price">
                  ${{plugin.price}}
                </div>
                <!--<div class="pos-order-confirmation text-center d-flex flex-column justify-content-center">
                  <div class="mb-1">
                    <i class="bi bi-trash fs-36px lh-1"></i>
                  </div>
                  <div class="mb-2">Remove this item?</div>
                  <div>
                    <a href="#" class="btn btn-outline-default btn-sm ms-auto me-2 width-100px">No</a>
                    <a href="#" class="btn btn-outline-theme btn-sm width-100px">Yes</a>
                  </div>
                </div>-->
              </div>
              </div>


            </div>


          
          </div>


          <div class="pos-sidebar-footer">
            <div class="d-flex align-items-center mb-2">
              <div>Total</div>
              <div class="flex-1 text-end h4 mb-0">AU${{this.formModel.Price}}</div>
            </div>
            <div class="mt-3">
              <div class="btn-group d-flex">
                
                <a class="btn btn-outline-default rounded-0 w-80px" (click)="gotoPlugins()" *ngIf="wizardStep == 0 && this.formModel.uriOption">
                  <i class="bi bi-plug fa-lg"></i><br>
                  <span class="small">Choose Plugins</span>
                </a>
                <a class="btn btn-outline-default rounded-0 w-80px"  (click)="gotoPurchase();doSave()" *ngIf="wizardStep == 1">
                  <i class="bi bi-receipt fa-fw fa-lg"></i><br>
                  <span class="small">Confirm</span>
                </a>
                <a class="btn btn-outline-theme rounded-0 w-150px"  (click)="doPurchase()" *ngIf="wizardStep == 2">
                  <i class="bi bi-send-check fa-lg"></i><br>
                  <span class="small">Submit Order</span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="card-arrow">
      <div class="card-arrow-top-left"></div>
      <div class="card-arrow-top-right"></div>
      <div class="card-arrow-bottom-left"></div>
      <div class="card-arrow-bottom-right"></div>
    </div>
  </div>

  <div class="row">


    
  </div>
</div>